import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Topbar from "../../../components/Topbar";
import Leftbar from "../../../components/Leftsidebar";
import { Link } from "react-router-dom";
import Loaderspinner from "../../../components/Loader";
import { Row, Col } from "react-bootstrap";
import { showToast } from "../../Utils/utils";
import ReactPaginate from "react-paginate";
import SweetAlert from "react-bootstrap-sweetalert";

const ButtonPage = ({
    type = 'user',
    idKey,
    getListApi,
    deleteApi,
}) => {
    const { id, resourceId } = useParams();

    const [loading, setLoading] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [buttonsList, setButtonsList] = useState([]);
    const [buttonId, setButtonId] = useState(null);
    const [showAlert, setShowAlert] = useState(false);

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    useEffect(() => {
        if (search.length === 0 || search.length >= 3) {
            fetchList();
        }
    }, [page, search]);

    const fetchList = async () => {
        if (!idKey) {
            console.error("idKey is missing!");
            return;
        }
        try {
            setLoading(true);

            const limit = 10;
            const offset = page * limit;

            const payload = {
                [idKey]: id,
                search,
                limit,
                offset,
            };

            const response = await getListApi(payload);

            if (response?.status === 200) {
                setButtonsList(response?.data?.rows);

                if ((response?.data?.count || 0) < limit) {
                    setTotalPages(page + 1);
                } else {
                    setTotalPages(page + 2);
                }
            }
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        const res = await deleteApi(buttonId);

        if (res.status === 200) {
            showToast("Deleted successfully", "success");
            fetchList();
        }

        setShowAlert(false);
    };

    return (
        <>
            <div class="g-sidenav-show  bg-gray-100 min-vh-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />
                        <div>
                            <div className="header header-bg pb-6">
                                <div className="container-fluid">
                                    <div className="header-body">
                                        <div className="row align-items-center py-4">
                                            <div className="col-lg-6 col-7">
                                                <nav
                                                    aria-label="breadcrumb"
                                                    className="d-none d-md-inline-block ml-md-4"
                                                >
                                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/dashboard">
                                                                <i className="fas fa-home" />
                                                            </Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to="/resources"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Resources</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to={`/manage-resource/${resourceId}`}><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Manage Resource</span></Link>
                                                        </li>
                                                        <li className="breadcrumb-item">
                                                            <Link to=""><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>{type == 'user' ? 'Agent' : 'Company'}</span></Link>
                                                        </li>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid mt--6">
                                <div className="row">
                                    <div className="col">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center justify-content-end mb-3">
                                                    <input
                                                        type="text"
                                                        className="search-input mx-2"
                                                        placeholder="Search"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                    />
                                                    <Link to={`${type == 'user' ? '/manage-user' : '/manage-company'}/${resourceId}/create-button/${id}`}>
                                                        <button className="export-btn"> Create Button </button>
                                                    </Link>
                                                </div>
                                                {loading ? <Loaderspinner /> :
                                                    <div className="row">
                                                        <div className="col">
                                                            <div className="table-responsive">
                                                                <table className="table align-items-center table-flush">
                                                                    <thead className="thead-light">
                                                                        <tr>
                                                                            <th>Sr.No</th>
                                                                            <th>Label</th>
                                                                            <th>Type</th>
                                                                            <th>Value</th>
                                                                            <th>Clicked</th>
                                                                            <th>Actions</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {buttonsList?.length > 0 ? (
                                                                            buttonsList.map((button, index) => (
                                                                                <tr key={index}>
                                                                                    <td>{index + 1}</td>
                                                                                    <td >{button?.text}</td>
                                                                                    <td>{button?.type}</td>
                                                                                    <td>{button?.value}</td>
                                                                                    <td>
                                                                                        <button className="viewproject-btn pull-right" style={{ width: "fit-content" }} >
                                                                                            {button?.connect_count || 0}
                                                                                        </button>
                                                                                    </td>
                                                                                    <td style={{ width: "140px" }}>
                                                                                        <button className="viewproject-btn pull-right mb-1" onClick={() => {
                                                                                            setButtonId(button?.id)
                                                                                            setShowAlert(true)
                                                                                        }} >
                                                                                            <span className="text-white">Delete</span>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            ))) :
                                                                            <tr>
                                                                                <td colSpan="10" className="text-center"><b>No records found</b></td>
                                                                            </tr>
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                <Row>
                                                    <Col xs={12}>
                                                        <div className='paginate-css'>
                                                            <ReactPaginate
                                                                previousLabel="<"
                                                                nextLabel=">"
                                                                breakLabel="..."
                                                                pageCount={totalPages}
                                                                marginPagesDisplayed={1}
                                                                pageRangeDisplayed={2}
                                                                onPageChange={({ selected }) => setPage(selected)}
                                                                containerClassName="pagination"
                                                                activeClassName="active"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
            {showAlert && (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Yes, delete it!"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="secondary"
                    title="Are you sure?"
                    onConfirm={handleDelete}
                    onCancel={() => setShowAlert(false)}
                    focusCancelBtn
                >
                    This action cannot be undone.
                </SweetAlert>
            )}
        </>
    );
};

export default ButtonPage